const SIGN_IN_URL = '/user/auth/sign-in';
const SIGN_UP_URL = '/user/auth/sign-up';
const LOGOUT_URL = '/user/auth/logout';

const REDUCER_MENU_NAME = 'menu';

export {
  SIGN_IN_URL,
  SIGN_UP_URL,
  LOGOUT_URL,

  REDUCER_MENU_NAME,
};
